import * as tslib_1 from "tslib";
import { interval } from 'rxjs';
import { map, takeUntil, skip } from 'rxjs/operators';
import { Selectors } from 'store/root-reducer';
import * as CustomerActions from 'store/actions/customer.actions';
import { BaseDataSource } from 'modules/shared/data-source/base.data-source';
var CustomersBatchUploadsHistoryDataSource = /** @class */ (function (_super) {
    tslib_1.__extends(CustomersBatchUploadsHistoryDataSource, _super);
    function CustomersBatchUploadsHistoryDataSource(store) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.initLoading();
        _this.setDataObservable();
        _this.pullFiles();
        return _this;
    }
    CustomersBatchUploadsHistoryDataSource.prototype.disconnect = function (collectionViewer) {
        _super.prototype.disconnect.call(this, collectionViewer);
        this.store.dispatch(new CustomerActions.ClearCustomersBatchUploadsList());
    };
    CustomersBatchUploadsHistoryDataSource.prototype.pullFiles = function () {
        var _this = this;
        interval(3000)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function () { return _this.loadData(); });
    };
    CustomersBatchUploadsHistoryDataSource.prototype.initLoading = function () {
        this.isLoading$ = this.store.select(Selectors.customer.getLoading)
            .pipe(takeUntil(this.unsubscribe$), map(function (customerLoading) {
            return customerLoading.includes(CustomerActions.CustomerActionTypes.GET_CUSTOMERS_BATCH_UPLOADS_LIST);
        }));
    };
    CustomersBatchUploadsHistoryDataSource.prototype.setDataObservable = function () {
        var _this = this;
        this._dataObservable$ = this.store
            .select(Selectors.customer.getCustomersBatchUploads)
            .pipe(skip(1), map(function (allFilesResponse) {
            _this.paginator.length = allFilesResponse.count;
            return allFilesResponse.results;
        }), takeUntil(this.unsubscribe$));
    };
    CustomersBatchUploadsHistoryDataSource.prototype.loadData = function () {
        this.store.dispatch(new CustomerActions.GetCustomersBatchUploadsList({ params: this.payload }));
    };
    return CustomersBatchUploadsHistoryDataSource;
}(BaseDataSource));
export { CustomersBatchUploadsHistoryDataSource };
